module.exports = __webpack_public_path__ + "files/0f7ef7e52dc208c6ebf455b229455044.png";